import { Box, Button, Divider, Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useState } from "react";
import { ErrorModal } from "../../../../../../../components/modals/error-modal";
import MesfModal from "../../../../../../../components/modals/modal.mesf";
import { ButtonWithLoading } from "../../../../../../../components/shared/buttons/button-with-loading";
import { useTrendingContext } from "../../../context/TrendingContext";
import {
	upsertView,
	upsertViewTag,
} from "../../../repository/TrendingRepository";
import { useTrendingStyles } from "../../../styles/TrendingStyles";

interface Props {
	open: boolean;
	handleClose: (shouldUpdate: boolean) => void;
}

export const SaveAsViewModal = ({ open, handleClose }: Props) => {
	const classes = useTrendingStyles();

	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	const {
		state: { viewTags, views, viewSelected },
		actions: { setViewSelected, setViewTags },
	} = useTrendingContext();
	const [isPublic, setIsPublic] = useState(true);
	const [newView, setNewView] = useState("");

	const handleCheck = () => setIsPublic(!isPublic);

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) =>
		setNewView(e.target.value);

	const handleSubmit = async () => {
		setIsLoading(true);
		const resp = await upsertView(null, newView, isPublic);

		if (resp.ok) {
			const ViewId = resp.data.returnValue;
			let shouldClose = true;

			const results = await Promise.allSettled(
				Object.values(viewTags).map(
					({
						viewTag: {
							TagId,
							Color,
							MinScale,
							MaxScale,
							IsAutoScale,
							IsVisible,
							Unit,
						},
					}) => {
						upsertViewTag(
							ViewId,
							TagId,
							Color,
							MinScale,
							MaxScale,
							IsVisible,
							IsAutoScale,
							Unit,
						).then((r) => {
							if (!r.ok) {
								setError((prevErr) => `${prevErr}. ${r.message}`);
								if (shouldClose) {
									shouldClose = false;
								}
							}
						});
					},
				),
			);

			handleClose(shouldClose);
		} else {
			setError(resp.message);
		}

		setIsLoading(false);
	};

	return (
		<>
			<MesfModal
				open={open}
				handleClose={() => handleClose(false)}
				maxWidth={"xl"}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				title="Save View As"
			>
				<Divider />

				<MesfModal.Content>
					<Grid container spacing={5} style={{ padding: "1rem" }}>
						<Grid
							item
							md={12}
							xs={12}
							style={{ padding: "10px", width: "100%" }}
						>
							{views.length && viewSelected ? (
								<Autocomplete
									size="small"
									id="list-of-views"
									options={views}
									defaultValue={viewSelected}
									getOptionLabel={(option) => option.ViewName}
									freeSolo
									onChange={(ev, val) => {
										setViewSelected(val);
										if (val) {
											setNewView("");
										}
									}}
									onInputChange={(event, newInputValue) => {
										const isValueInViews = views.some(
											(view) => view.ViewName === newInputValue,
										);
										if (!isValueInViews) {
											setNewView(newInputValue);
										}
									}}
									style={{ width: "100%" }}
									renderInput={(params) => (
										<TextField {...params} label="Views" variant="outlined" />
									)}
								/>
							) : (
								<Box>
									<TextField
										style={{ minWidth: "600px" }}
										size="small"
										id="outlined-basic"
										label="View name"
										variant="outlined"
										value={newView}
										onChange={(e) => setNewView(e.target.value)}
									/>
								</Box>
							)}
						</Grid>
					</Grid>
					<Grid
						item
						md={12}
						xs={12}
						style={{ paddingTop: "2rem" }}
						className={classes.isPublicCheckbox}
					>
						<label>
							Public
							<input
								type="checkbox"
								checked={isPublic}
								onChange={handleCheck}
							/>
						</label>
					</Grid>
				</MesfModal.Content>
				<Divider />
				<MesfModal.Actions>
					<Grid
						container
						spacing={1}
						style={{
							display: "flex",
							alignItems: "flex-end",
							justifyContent: "flex-end",
						}}
					>
						<Grid item>
							<Button
								variant="outlined"
								color="secondary"
								onClick={() => handleClose(false)}
							>
								Cancel
							</Button>
						</Grid>
						<Grid item>
							<ButtonWithLoading
								variant="contained"
								color="primary"
								onClick={handleSubmit}
								isLoading={isLoading}
							>
								Save
							</ButtonWithLoading>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
